import { Controller } from "@hotwired/stimulus"

// This controller manages filters that use a single input (such as a text, number or select input).
export default class extends Controller {
  static get targets() {
    return ["input"]
  }

  static get values() {
    return { name: String }
  }

  apply() {
     this.dispatchFilterEvent()
  }

  clear() {
    this.inputTarget.value = ""
    this.dispatchFilterEvent()
  }

  dispatchFilterEvent() {
    let values = []

    if (this.inputTarget.value !== "") {
      values = [this.inputTarget.value]
    }

    this.dispatch("filter", { detail: { name: this.nameValue, values: values } })
  }
}
